import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

import CustomButton from "components/CustomButton";

import {black500} from "assets/jss/main";

import {sessionStore} from "utils/sessionStore";
import {Authorizations, hasAuthorization} from "utils/authorizations";

AssignButton.propTypes = {
    onClick: PropTypes.func,
    loading: PropTypes.bool,
};

function AssignButton({onClick, loading = false}) {
    const authorizations = sessionStore.get('authorizations');

    if (hasAuthorization(authorizations, Authorizations.PICKING_RETAILER)) {
        return null;
    }

    return (
        <CustomButton
            color="default"
            variant="outlined"
            loading={loading}
            onClick={onClick}
        >
            <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4 8H12" stroke={black500} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M8 12V4" stroke={black500} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <FormattedMessage id="oms.order.list.assign.compact" />
            </div>
        </CustomButton>
    );
}

export default AssignButton;
